import { ISnotrRoute } from '..';

export default [
  {
    path: '/employees',
    name: 'Employees',
    meta: {
      title: 'TabTitle.employees',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/employees.vue'),
  },
  {
    path: '/employees/new',
    name: 'EmployeesNew',
    meta: {
      title: 'TabTitle.newEmployee',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/employees-new.vue'),
  },
  {
    path: '/employees/:id',
    name: 'EmployeesEdit',
    meta: {
      title: 'TabTitle.editEmployee',
      applicationMode: 'PaycheckMode',
    },
    props: route => {
      return { isNewEmployee: ('new_employee' in route.query) };
    },
    component: () => import('@/pages/employees-edit.vue'),
  },
] as ISnotrRoute[];
